import { getCurrentGroup } from './basic';

const getPatientGroup = (state: IAppState) => {
  return (
    state.groups.groupInfo.data.find((group) => group.gid === state.patient.data?.subgroup_gid) ||
    getCurrentGroup(state)
  );
};

const getPatientOrg = (state: IAppState) => {
  const patientGid = state.patient.data?.subgroup_gid;
  const patientGroup = state.groups.groupInfo.data.find((group) => group.gid === patientGid);
  return state.groups.groupInfo.data.find((group) => group.gid === patientGroup?.parentGid);
};

const selectLastOpenedUid = (state: IAppState) => state.groups.lastOpenedUid;

export { getPatientGroup, getPatientOrg, selectLastOpenedUid };
